import { Model } from '@vuex-orm/core'

export default class Company extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'companies'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      country: this.attr(null),
      region: this.attr(null),
      city: this.attr(null),
      neighborhood: this.attr(null),
      address: this.attr(null),
      zipcode: this.attr(null),
      description: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Company.js